module.exports = "<h1 class=\"bluetext\" style=\"text-align: center\">This is not the page you were looking for!</h1>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pagenotfound/page-not-found.component.html
// module id = ./src/app/pagenotfound/page-not-found.component.html
// module chunks = main